<template>
  <page-outline :title="$t('tracking.tracks_bulk_details')">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" sm="3" md="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>

        <spinner v-if="activateSpinner"></spinner>
        <template v-else-if="Tracking">
          <div>
            <form-accordion :title="$t('tracking.details')" :isTitleUpperCase="false">
              <b-row class="form-group justify-content-start" v-if="Tracking.FileName !== '' || Tracking.Date !== '' || Tracking.idTrackingBulk !== ''">
                <b-col sm="4" class="mb-5">
                  <form-read-group-label-input v-if="Tracking.FileName !== ''"
                    :inputLabel="$t('tracking.file_name')" :inputValue="Tracking.FileName">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5" v-if="Tracking.Date !== ''">
                  <form-read-group-label-input
                    :inputLabel="$t('tracking.date')" :inputValue="getDateDay(Tracking.Date)">
                  </form-read-group-label-input>
                </b-col>
                <b-col sm="4" class="mb-5">
                  <label id="" class="">{{ $t('tracking.file') }}</label>
                  <div class="d-flex justify-content-start align-item-start">
                    <div>
                      <i class="fa fa-eye cursor pl-2 pr-1 color-var-actionButtonColorBlue" @click="seeJson(Tracking.idTrackingBulk, 'trackingBulk', 'see')"></i>
                    </div>
                    <div>
                      <i class="fa fa-download cursor px-2 color-var-actionButtonColorBlue" @click="seeJson(Tracking.idTrackingBulk, 'trackingBulk', 'download')"></i>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </form-accordion>
          </div>
          <hr />
          <div>
            <form-accordion :title="$t('tracking.lines')" :isTitleUpperCase="false">
              <!-- <b-table
                :items="Tracking.Lines"
                :fields="fields"
                class="table table-striped" v-if="Tracking.Lines && Tracking.Lines.length"
                :selectable="Tracking.Lines.length > 0"
                @row-selected="seeTracksBulkDetails">

                <template #cell(Status)="data">
                  <span><i :class="calculateStatuses(data.item)"></i></span>
                </template>
              </b-table> -->
              <div v-if="TracksList.length > 0" style="overflow:auto">
                <b-table hover
                  class="table table-striped mb-0"
                  :fields="fieldsTrack"
                  :items="TracksList"
                  :selectable="TracksList.length > 0"
                  :empty-text="$t('common.security.no_result')"
                  @row-selected="seeTracksDetails">
                  <template #cell(CreationDateRq1)="data">
                    <span>{{ getDateDay(data.value) }}</span>
                  </template>
                  <template #cell(CreationDateRp2)="data">
                    <span>{{ getDateDay(data.value) }}</span>
                  </template>
                  <template #cell(BICFrom)="data">
                    <span>{{ data.value }}</span>
                  </template>
                  <template #cell(BICTo)="data">
                    <span>{{ data.value }}</span>
                  </template>
                  <template #cell(IBAN)="data">
                    <span>{{ data.value }}</span>
                  </template>
                  <template #cell(Status)="data">
                    <span>{{ data.value }}</span>
                  </template>
                  <template #cell(Name)="data">
                    <span>{{ data.item.FullName }}</span>
                  </template>
                  <template #cell(TestedData)="data">
                    <span v-if="data.item.FullName !== ''">{{ data.item.FullName }}</span>
                    <span v-else-if="data.item.Siren !== ''">{{ data.item.Siren }}</span>
                    <span v-else-if="data.item.Siret !== ''">{{ data.item.Siret }}</span>
                    <span v-else-if="data.item.TVA !== ''">{{ data.item.TVA }}</span>
                    <span v-else> - </span>
                  </template>
                  <template #cell(Result)="data">
                    <span v-if="data.item.IdScore !== ''">{{ data.item.IdScore }}</span>
                    <span v-else-if="data.item.NameScore !== ''">{{ data.item.NameScore }}</span>
                    <span v-else> - </span>
                  </template>
                  <template #cell(TechStatusCode)="data">
                    <span v-if="data.item.TechStatusCode !== ''">{{ translateTechStatusCode(data.item.TechStatusCode) }}</span>
                    <span v-else>{{ $t('common.monitoring.success') }} </span>
                  </template>
                </b-table>
              </div>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>
            </form-accordion>
          </div>
          <!--<hr />
          <div>
            <form-accordion :title="$t('tracking.history')" :isTitleUpperCase="false">
              <table class="table table-striped" v-if="Tracking.History && Tracking.History.length">
                <tbody>
                  <tr>
                    <th class="text-center w-25">
                      {{ $t('tracking.status') }}
                    </th>
                    <th class="text-center w-25">
                      {{ $t('tracking.status_code') }}
                    </th>
                    <th class="text-center w-25">
                      {{ $t('tracking.processing_date') }}
                    </th>
                  </tr>
                  <tr v-for="history in Tracking.History" :key="history.id">
                    <td class="text-center w-25">
                      <div v-if="history.Status !== ''">{{ $t('tracking.status-' + history.Status) }}</div>
                    </td>
                    <td class="text-center w-25">
                      <div v-if="history.StatusCode !== ''">{{ translateTechStatusCode(history.StatusCode) }}</div>
                    </td>
                    <td class="text-center w-25">
                      {{ getDate(history.Date) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </form-accordion>
          </div>-->

        </template>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import formAccordion from "@/components/common/FormAccordion.vue";
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue";
import {errorMessageAlert} from "@/helpers/alert";
import { downloadFileWithDefinedHeaders } from '@/helpers/download'
import moment from "moment";
import {DOMParser} from "xmldom";
import TrackingPage from "@/pages/tracking/TrackingPage.vue";
import {loadPage} from "@/helpers/routing";

export default {
  name: 'TrackingBulkDetails',
  components: {
    TrackingPage,
    FormReadGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner,
    'form-accordion': formAccordion,
  },
  computed: {

    fields () {
      let fields
      fields = [
        { key: 'idMsg', label: this.$i18n.t('tracking.id_track'), class: 'text-center', sortable: false },
        { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
        { key: 'Name', label: this.$i18n.t('tracking.name'), class: 'text-center', sortable: false },
        { key: 'Siren', label: this.$i18n.t('tracking.siren'), class: 'text-center', sortable: false },
        { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: false },
        { key: 'TVAIntracom', label: this.$i18n.t('tracking.tva_intracom'), class: 'text-center', sortable: false },
        { key: 'MatchedName', label: this.$i18n.t('tracking.matched_name'), class: 'text-center', sortable: false },
        { key: 'Status', label: this.$i18n.t('tracking.status'), class: 'text-center', sortable: false },
      ]

      return fields
    },
    fieldsTrack () {
      let fields
        fields = [
          { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), thClass: 'min-w-160px', class: 'text-center', sortable: false },
          { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
          { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
          { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
          { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
          { key: 'TestedData', label: this.$i18n.t('tracking.tested_data'), class: 'text-center', sortable: false },
          { key: 'Result', label: this.$i18n.t('tracking.maching_result'), class: 'text-center', sortable: false },
          { key: 'TechStatusCode', label: this.$i18n.t('tracking.technical_code'), class: 'text-center', sortable: false },
          // { key: 'CompanyName', label: this.$i18n.t('tracking.company_name'), class: 'text-center', sortable: true },
          // { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: true },
          // { key: 'TVA', label: this.$i18n.t('tracking.tva'), class: 'text-center', sortable: true },
          // { key: 'AccountType', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: true },
        ]
      return fields
    },
    canUserDelete () {
      return this.$engine.rights.rightIs('usercompany_delete', true) || this.$engine.rights.rightIs('usercompany_delete_admin', true)
    },
    canUserEdit () {
      return this.$engine.rights.rightIs('usercompany_edit', true) || this.$engine.rights.rightIs('usercompany_edit_admin', true)
    },
    listTitle () {
      return 'Details de l\'utilisateur'
    }
  },
  props: ['id', 'type'],
  data () {
    return {
      activateSpinner: false,
      returnUrl: '',
      Tracking: {},
      TracksList: []
    }
  },
  created () {
    this.defineReturnURL()
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details de l\'utilisateur',
      // returnUrl: ''
    })

    this.$engine.settings.set({msgDirection: this.direction})
    this.getTrack()
    this.getTracks()
    this.$f7.initPullToRefresh()
    this.pageCounter = 0


    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    activateDetail (id) {
      let that = this
      const idTrackingBulk = this.$route.params.id
      loadPage(that, {url: '/trackingdetails/BULK/' + id + '?idTrackingBulk=' + idTrackingBulk })
    },
    activateDetailBulk (id) {
      let that = this
      loadPage(that, {url: '/tracking/BULKDETAILS/' + id})
    },
    seeTracksDetails (items) {
      this.activateDetail(items[0].IdTrack)
    },
    seeTracksBulkDetails (items) {
      this.activateDetailBulk(items[0].IdVopMessageLineBulk)
    },
    getStatus(value, score) {
      if (value && score == 'MTCH') {
        return 'MTCH';
      } else if (value && score == 'NCTC') {
        return 'NCTC';
      } else if (value && score == 'NOAP') {
        return 'NOAP';
      } else if (value && score == 'CMTC'){
        return 'CMTC';
      } else {
        return null;
      }
    },
    calculateStatuses(line) {
      // Définit les statuts pour chaque champ
      const statuses = {
        Name: this.getStatus(line.Name, line.NameScore),
        Siren: this.getStatus(line.Siren, line.SirenScore),
        Siret: this.getStatus(line.Siret, line.SiretScore),
        TVAIntracom: this.getStatus(line.TVAIntracom, line.TVAIntracomScore),
      }

      // Calcule le statut global
      const uniqueStatuses = new Set(Object.values(statuses))

      let globalStatus = null
      if (uniqueStatuses.has('NCTC')) {
        globalStatus = 'NCTC'
      } else if (uniqueStatuses.has('NOAP') || uniqueStatuses.has('CMTC')) {
        globalStatus = 'NOAP'
      } else {
        globalStatus = 'MTCH'
      }

      if (globalStatus == 'MTCH'){
        return "fa-solid fa-check text-success"
      }
      if (globalStatus == 'NCTC'){
        return "fa-solid fa-xmark text-danger"
      }
      if (globalStatus == 'NOAP'){
        return "fa-solid fa-triangle-exclamation text-warning"
      }
      if (globalStatus == null){
        return "fa-solid fa-ban"
      }
    },
    isXML (str) {
      try {
        const parser = new DOMParser()
        const jsonDoc = parser.parseFromString(str, 'text/xml')
        return jsonDoc.documentElement.nodeName !== 'parsererror'
      } catch (e) {
        return false
      }
    },
    isJSON (str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    isCSV(str) {
      const lines = str.split('\n')
      return lines.length > 1 && lines[0].includes(';')
    },
    seeJson (IdMsg, service, action) {
      let that = this
      const id = IdMsg
      let dataDetails = {}
      this.$engine.tracking.getJSON({service, id})
      .then((resp) => {
        if (resp.data) {
          dataDetails.data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
          dataDetails.type = service
          if (action === 'see') {
            that.$bus.emit('popup-json-details', dataDetails)
          } else {
            //download file
            let data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
            // if (this.isXML(data)){
            //   const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.xml'
            //   const blob = new Blob([data], { type: 'text/xml' })
            //
            //   downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
            //   that.$f7.alert('', that.$i18n.t('common.xml_downloaded'))
            // }
            // if (this.isJSON(data)){
            //   const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.json'
            //   const blob = new Blob([data], { type: 'application/json' })
            //
            //   downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
            //   that.$f7.alert('', that.$i18n.t('common.json_downloaded'))
            // }
            if (this.isCSV(data)){
              const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.csv'
              const blob = new Blob([data], { type: 'text/csv' })

              downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
              that.$f7.alert('', that.$i18n.t('common.csv_downloaded'))
            }
          }
        }
      })
      .catch((error) => {
        errorMessageAlert(error, that)
      })
    },
    getDateDay (date) {
      return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss')
    },
    getDate (date) {
      return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss.SSS')
    },
    translateTechStatusCode (code) {
      if (this.$t('tracking.error-status.' + code) !== 'tracking.error-status.' + code) {
        return this.$t('tracking.error-status.' + code)
      } else {
        return this.$t('tracking.error-status.default', { statusCode: code })
      }

    },
    defineReturnURL () {
      this.returnUrl = '/tracking/BULK/NULL'
    },
    getTrack () {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = {
        IdTrackBulk: this.id
      }
      that.$engine.tracking.getTracksBulk(
        filterConditions
      )
      .then(resp => {
        let requests = {}
        if (resp.data && resp.data.trackingBulk && resp.data.trackingBulk.length) {
          that.Tracking = resp.data.trackingBulk[0]
        }
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getTracks() {
      let that = this
      this.pageCounter = 0

      this.activateSpinner = true

      let filterConditions = {
        Type: 'DDV'
      }

      if (this.id !== 'NULL') {
        filterConditions.IdBulk = this.id
      }

      this.$engine.tracking.getTracks(
        filterConditions
      )
      .then(resp => {
        let tracksList = {}
        if (resp.data && resp.data.tracks.length > 0) {
          tracksList = resp.data.tracks
        }
        that.updateTracksList(tracksList)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    hasProfileTrad (profileName) {
      let trad = this.$i18n.t('rights.db_profiles.' + profileName)
      if (trad === ('rights.db_profiles.' + profileName)) {
        return profileName
      }
      return trad
    },
    updateTracksList (trackList) {
      this.TracksList = trackList
    }
  }
}
</script>
